import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;



// WEBPACK FOOTER //
// ./../../../../小梁/Desktop/reservation_server/web/src/event_bus.js